import FleetHelpers, {FLEET_BASE, extractFleetError, fleetFieldErrors, saveXlsxBlob} from './FleetHelpers';

/**
 * Truck registry (T015, US1/FR-001..002).
 * GET/POST /api/v1/fleet/trucks, PUT/DELETE /api/v1/fleet/trucks/{id}.
 * List envelope: {data:[TruckResource], meta:{current_page,last_page,total}}.
 */
export default {
    mixins: [FleetHelpers],
    data: () => ({
        trucks: [],
        isLoading: true,
        btnLoading: false,
        count: 0,

        // Filters
        searchItem: '',
        selectedSizeClass: '',
        selectedActive: '',

        // Pagination (resource collection meta)
        offset: 10,
        pagination: {},
        per_page: 15,

        truckId: '',
        filterTruck: {},
        server_errors: {},

        truckValue: {
            plate_number: '',
            vehicle_type: '',
            size_class: 'medium',
            capacity_kg: '',
            capacity_cbm: '',
            ownership: 'company',
            team_name: '',
            is_active: true,
        },

        sizeClassOptions: [
            {id: 'small', name: 'ລົດນ້ອຍ (small)'},
            {id: 'medium', name: 'ລົດກາງ (medium)'},
            {id: 'large', name: 'ລົດໃຫຍ່ (large)'},
        ],
        // Driver picker for a truck's default crew (ໂຊເຟີ້ປະຈຳລົດ).
        driverOptions: [],
        driverOptionsLoading: false,

        ownershipOptions: [
            {id: 'company', name: 'ລົດບໍລິສັດ'},
            {id: 'contractor', name: 'ລົດຜູ້ຮັບເໝົາ'},
        ],
    }),
    methods: {
        FetchTrucks() {
            this.isLoading = true;
            this.$http.get(`${FLEET_BASE}/trucks`, {
                params: {
                    q: this.searchItem || undefined,
                    size_class: this.selectedSizeClass || undefined,
                    is_active: this.selectedActive === '' ? undefined : this.selectedActive,
                    page: this.pagination.current_page || 1,
                    per_page: this.per_page,
                },
            }).then((res) => {
                this.trucks = res.data.data || [];
                this.pagination = res.data.meta || {};
                this.count = this.pagination.total || this.trucks.length;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },
        FilterTrucks() {
            this.pagination.current_page = 1;
            this.FetchTrucks();
        },
        ResetTruckForm() {
            this.server_errors = {};
            this.truckValue = {
                plate_number: '',
                vehicle_type: '',
                size_class: 'medium',
                capacity_kg: '',
                capacity_cbm: '',
                ownership: 'company',
                team_name: '',
                is_active: true,
            };
        },
        CreateTruck() {
            this.btnLoading = true;
            this.server_errors = {};
            this.$http.post(`${FLEET_BASE}/trucks`, this.truckValue).then(() => {
                this.btnLoading = false;
                this.$emit('close');
                this.$emit('success');
                this.$notification.OpenNotification_AddItem_OnSuccess('top-right', 'dark', 3000);
            }).catch((error) => {
                this.btnLoading = false;
                this.server_errors = fleetFieldErrors(error);
                if (!Object.keys(this.server_errors).length) {
                    this.$notification.error({message: extractFleetError(error)});
                }
            });
        },
        UpdateTruck() {
            this.btnLoading = true;
            this.server_errors = {};
            this.$http.put(`${FLEET_BASE}/trucks/${this.truckValue.id}`, this.truckValue).then(() => {
                this.btnLoading = false;
                this.$emit('close');
                this.$emit('success');
                this.$notification.OpenNotification_EditItem_OnSuccess('top-right', 'dark', 3000);
            }).catch((error) => {
                this.btnLoading = false;
                this.server_errors = fleetFieldErrors(error);
                if (!Object.keys(this.server_errors).length) {
                    this.$notification.error({message: extractFleetError(error)});
                }
            });
        },
        // Bulk truck / default-crew upload (TMS report #7).
        DownloadTruckTemplate() {
            return this.$http.get(`${FLEET_BASE}/trucks/import/template`, {responseType: 'blob'})
                .then((response) => saveXlsxBlob(response, 'ແບບຟອມອັບໂຫຼດລົດ.xlsx'))
                .catch((error) => {
                    this.$notification.error({message: extractFleetError(error)});
                });
        },
        // dryRun=true previews the exact diff without writing anything.
        ImportTrucks(file, dryRun) {
            const form = new FormData();
            form.append('file', file);
            form.append('dry_run', dryRun ? '1' : '0');
            return this.$http.post(`${FLEET_BASE}/trucks/import`, form, {
                headers: {'Content-Type': 'multipart/form-data'},
            }).then((res) => res.data.data).catch((error) => {
                this.$notification.error({message: extractFleetError(error)});
                return Promise.reject(error);
            });
        },
        FetchDriverOptions() {
            this.driverOptionsLoading = true;
            return this.$axios.get('list-vehicle-department-users', {params: {per_page: 1000}}).then((res) => {
                const rows = (res.data.listVehicleDepartmentUsers && res.data.listVehicleDepartmentUsers.data) || [];
                this.driverOptions = rows.map((row) => ({
                    id: row.vehicleDepartmentUserId,
                    pickerLabel: `${row.userName || '...'}${row.userTel ? ' (' + row.userTel + ')' : ''}${row.userCardid ? ' · ລະຫັດ ' + row.userCardid : ''}`,
                }));
                this.driverOptionsLoading = false;
            }).catch(() => {
                this.driverOptionsLoading = false;
            });
        },
        // Replace a truck's default crew — driverIds primary first.
        SetTruckDefaultDrivers(truckId, driverIds) {
            return this.$http.put(`${FLEET_BASE}/trucks/${truckId}/default-drivers`, {driver_ids: driverIds})
                .then((res) => {
                    this.$notification.OpenNotification_EditItem_OnSuccess('top-right', 'dark', 3000);
                    return res.data.data;
                }).catch((error) => {
                    this.$notification.error({message: extractFleetError(error)});
                    return Promise.reject(error);
                });
        },
        DeleteTruck(truckId) {
            this.btnLoading = true;
            this.$http.delete(`${FLEET_BASE}/trucks/${truckId}`).then(() => {
                this.btnLoading = false;
                this.$emit('close');
                this.$emit('success');
                this.$notification.OpenNotification_DeleteItem_OnSuccess('top-right', 'dark', 3000);
            }).catch((error) => {
                this.btnLoading = false;
                // 422 TRUCK_HAS_TRIPS -> deactivate instead of delete.
                this.$notification.error({message: extractFleetError(error)});
            });
        },
    },
};
